import { useQuery } from '@apollo/client';
import { UsersList } from '@nile/banyan/src/Components/Lists';
import { reactSelectInlineError } from '@nile/banyan/src/Utils/style';
import {
  getTranslatedText,
  NoDataCard,
  SelectionSheet
} from '@nile/components';
import { AccountClient } from '@nile/graphql';
import { GET_COMPANY_USERS } from '@nile/graphql/src/Query/automationrules';
import envConfig from '@nile/home/src/Config/env';
import {
  Button,
  DisplayText,
  ResourceList,
  Sheet
} from '@superops/ui-design-system';
import { SVGIcon } from '@superops/super-icons';
import React, { useCallback, useState } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';

function TechnicianUserList(props) {
  const { intl } = props;
  const [sheetActive, setSheetActive] = useState(false);
  const [selectedItems, setSelectedItems] = useState(
    props.userList
      ? props.userList.map((el) => {
          return {
            ...el,
            id: el.userId,
            name: el.name,
            label: `${el.firstName} ${el.lastName}`
          };
        })
      : []
  );
  const { loading, error, data: allEmployees } = useQuery(GET_COMPANY_USERS, {
    client: AccountClient,
    variables: {
      listInfo: {
        sort: {
          attribute: 'name',
          order: 'ASC'
        }
      }
    }
  });
  const toggleSheetActive = useCallback(
    () => setSheetActive((sheetActive) => !sheetActive),
    []
  );

  const updateParent = (items) => {
    setSelectedItems(items);
    props.updateUserList(items);
  };

  if (loading) return <div>loading...</div>;
  const employees = allEmployees?.getCompanyUsersList?.userList;
  let sections = [];
  const employeeSection = {
    name: 'client',
    header: getTranslatedText(intl, 'admin.Techniciangroup.technician.alltech'),
    items: employees?.map((el) => {
      return {
        ...el,
        id: el.userId,
        name: el.name,
        label: `${el.firstName} ${el.lastName}`
      };
    })
  };

  sections.push(employeeSection);

  return (
    <div className="fx col w100">
      <div className="fx">
        <div className="fx2 Technician-Group-Association f-20 mt-14 mb-14">
          <div className="fx actr plr-20">
            <DisplayText size="extraLarge" weight="SemiBold">
              <FormattedMessage id="admin.Techniciangroup.Technicians" />
            </DisplayText>
          </div>
        </div>
        <div className="fx2 fx actr jend">
          <Button
            onClick={toggleSheetActive}
            id="techUser"
            icon={<SVGIcon name="AssignToMeIcon" />}
          >
            <FormattedMessage id="common.edit" />
          </Button>
        </div>
        <Sheet open={sheetActive} onClose={toggleSheetActive}>
          <SelectionSheet
            sections={sections}
            actions={props.actions}
            meta={{
              heading: getTranslatedText(
                intl,
                'admin.Techniciangroup.associateemp.list'
              ),
              selectedTitle: getTranslatedText(
                intl,
                'admin.Techniciangroup.selectedemp.list'
              )
            }}
            selectedItems={selectedItems}
            toggleSheetActive={toggleSheetActive}
            updateParent={updateParent}
          />
        </Sheet>
      </div>
      {selectedItems.length === 0 ? (
        <div className="full-width flex center jcenter mt-30">
          <NoDataCard
            imageURL={`url(${envConfig.imageRoot}svg/documents-empty-state.svg)`}
            text={
              <FormattedMessage id="admin.technicianGroup.technicians.empty" />
            }
            type="secondary"
          />
        </div>
      ) : (
        <div className="Technician-Group-List">
          <ResourceList
            items={selectedItems}
            renderItem={UsersList.bind(this, props.associateEmployees)}
          />
          {props.errors?.technicians &&
            reactSelectInlineError(props.errors.technicians[0])}
        </div>
      )}
    </div>
  );
}

export default injectIntl(TechnicianUserList);
